function formatCurrency(value: number): string {
    return value.toLocaleString("en-US", {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
    });
}

// Generates the error message specifically for admins that the payment amount is outside the Novi allowed limit
export const AdminPaymentLimitsMessages = {
    achMax: (limit?: number) =>
        buildAdminMaxLimitMessage(limit, "ACH"),

    ccMax: (limit?: number) =>
        buildAdminMaxLimitMessage(limit, "credit card"),
};

// Generates the error message specifically for admins when the total is OVER the payment limit set by Novi
const buildAdminMaxLimitMessage = (paymentLimit?: number, paymentType?: string) => {
    if (paymentLimit == null || !paymentType) {
        return `To reduce financial risk, Novi does not process transactions of this size. Contact Novi with additional questions.`;
    }

    return `To reduce financial risk, Novi does not process ${paymentType} transactions over $${formatCurrency(paymentLimit)}. Contact Novi with additional questions.`;
};

// Generates the error message to inform the user that the payment is outside the allowed limit set by the association
// Will need to add achMin and ccMin when those cards are worked
export const PaymentLimitsMessages = {
    achMax: (tenant?: string, limit?: number) =>
        buildMaxLimitMessage(tenant, limit, "ACH"),

    ccMax: (tenant?: string, limit?: number) =>
        buildMaxLimitMessage(tenant, limit, "credit card"),
};

const genericLimitMessage = "This payment is outside the allowed payment limits. Please contact us to make alternative arrangements.";

// Generates the error message when the total is OVER the payment limit set by the association
const buildMaxLimitMessage = (tenantNameAbbreviated?: string, paymentLimit?: number, paymentType?: string) => {
    if (!tenantNameAbbreviated || paymentLimit == null || !paymentType) {
        return genericLimitMessage;
    }

    return `To help keep our expenses low, ${tenantNameAbbreviated} does not accept ${paymentType} payments over $${formatCurrency(paymentLimit)}. Please contact us to make alternative arrangements.`;
};

// Generates the error message when the total is UNDER the payment limit
// Will be implemented with achMin and ccMin
const buildMinLimitMessage = (tenantNameAbbreviated?: string, paymentLimit?: number, paymentType?: string) => {
    if (!tenantNameAbbreviated || paymentLimit == null || !paymentType) {
        return genericLimitMessage;
    }

    return `${tenantNameAbbreviated} does not accept ${paymentType} payments under $${formatCurrency(paymentLimit)}. Please increase your payment amount or contact us for assistance.`;
};